<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'SELECT_DEALER' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    </button>
</div>

<div class="modal-body p-0">
  <app-search-dealers [redirectUrl]="redirectUrl"></app-search-dealers>
</div>
